// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/index'

/* eslint-disable no-new */
new Vue({
  el: '#loading-mask',
  store,
  render: h => h(App)
})



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/